module.exports = function() {
  return new Worker(__webpack_public_path__ + "9c90805ce201534442ff.worker.js");
};